import { getPwywPlaceholder } from './getPwywPlaceholder';

/**
 * Placeholder for the pay-what-you-want ticket amount input. Thin wrapper
 * around the shared getPwywPlaceholder (suggested wins over the minimum;
 * neither set → generic enter-amount label, never "Min. $0") that maps the
 * ticket-specific theme labels onto the shared ones.
 */
export default function getTicketPwywPlaceholder({ ticketType, labels, currency, locale }) {
  const minAmount = Number(ticketType.price) || 0;
  const suggested = Number(ticketType.pwywSuggestedPrice) || 0;

  // A suggested price below the minimum can only come from unvalidated API
  // input — never advertise an amount the checkout would reject.
  const suggestedAmount = suggested >= minAmount ? suggested : 0;

  return getPwywPlaceholder({
    minAmount,
    suggestedAmount,
    currency,
    locale,
    labels: {
      payWhatYouWantPlaceholderText: labels.ticketPwywEnterAmountPlaceholderText,
      pwywSuggestedPricePlaceholderText: labels.ticketPwywSuggestedPricePlaceholderText,
      pwywMinPricePlaceholderText: labels.ticketPwywMinPricePlaceholderText,
    },
  });
}
